import {
  Result,
  RESULT_VARIANT_ERROR,
  RESULT_VARIANT_SUCCESS,
} from '@sgcmpteltd/uikit-react/components/result';
import cx from 'clsx';
import { useState } from 'react';

import { ACTION_STATUS_ERROR, ACTION_STATUS_SUCCESS } from '@/actions';
import {
  reportError,
} from '@/actions/misc/home/report-error/new-car-promotion/post';
import type {
  ReportErrorResult,
} from '@/app/(routes)/(misc)/pricelists/_components/page-content/pi-pricelist-content/types'; // @suppress longLineCheck
import {
  Step as ReportErrorContent,
} from '@/app/(routes)/(misc)/pricelists/_components/page-content/report-error';
import { PlainModal } from '@/components/modals/plain-modal';

import {
  MODAL_TITLE,
  PROCESS_RESULT_MESSAGE_REPORT_ERROR_FAIL,
  PROCESS_RESULT_MESSAGE_REPORT_ERROR_SUCCESS,
  PROCESS_RESULT_TITLE_REPORT_ERROR_FAIL,
  PROCESS_RESULT_TITLE_REPORT_ERROR_SUCCESS,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ReportErrorModal: Component = ({
  isOpen,
  onClose,
}) => {
  const currentUrl = window.location.href;
  const [
    reportErrorResultData, setReportErrorResultData,
  ] = useState<ReportErrorResult | null>(null);
  const [
    reportErrorStep, setReportErrorStep,
  ] = useState<'reportError' | 'errorSubmitResult'>('reportError');

  return (
    <PlainModal
      className={cx(
        styles.containerReportErrorModal,
        styles.hasBottomPadding,
        reportErrorStep === 'errorSubmitResult' && styles.isSubmmitted,
      )}
      isOpen={isOpen}
      modalTitle={reportErrorStep === 'reportError' ? MODAL_TITLE : ''}
      onClose={onClose}>
      {reportErrorStep === 'reportError'
      && (
        <ReportErrorContent
          onSubmit={async ({
            email: errorReportEmail,
            description: errorReportDescription,
            name: errorReportSenderName,
          }) => {
            const formData = new FormData();

            formData.set('email', errorReportEmail);
            formData.set('description', errorReportDescription);
            formData.set('link', currentUrl.toString());
            formData.set('name', errorReportSenderName);

            const actionResult = await reportError(formData);

            switch (actionResult.status) {
              case ACTION_STATUS_SUCCESS:
                setReportErrorResultData({
                  isSuccess: true,
                  title: PROCESS_RESULT_TITLE_REPORT_ERROR_SUCCESS,
                  message: PROCESS_RESULT_MESSAGE_REPORT_ERROR_SUCCESS,
                });

                break;
              case ACTION_STATUS_ERROR:
              default:
                setReportErrorResultData({
                  isSuccess: false,
                  title: PROCESS_RESULT_TITLE_REPORT_ERROR_FAIL,
                  message: PROCESS_RESULT_MESSAGE_REPORT_ERROR_FAIL,
                });
                break;
            }

            setReportErrorStep('errorSubmitResult');
          }} />
      )}
      {reportErrorStep === 'errorSubmitResult' && reportErrorResultData
      && (
        <Result
          message={reportErrorResultData.message}
          title={reportErrorResultData.title}
          variant={
            reportErrorResultData.isSuccess
              ? RESULT_VARIANT_SUCCESS
              : RESULT_VARIANT_ERROR
          } />
      )}
    </PlainModal>
  );
};
